"use client";

import { useIsDark } from "@/context/ThemeContext";
import { twMerge } from "tailwind-merge";

export default function DataLayout({ children }) {
    const isdark = useIsDark();
  return (
    <div>
      {/* left top  */}
      <section className="relative translate-x-0  xl:translate-y-0">
      <div className={twMerge("absolute top-[380px] xl:top-[472px] left-[-63px] w-[152px] h-[136px] xl:w-[313px] xl:h-[272px] rounded-full rotate-126 blur-[100px]",  isdark ? "bg-[#8593E8] opacity-40" : "bg-[#A1ADF5] opacity-60")}/>
      <div className={twMerge("absolute top-[470px] xl:top-[618px] left-[-100px] xl:left-[-244px] w-[153px] h-[137px] xl:w-[315px] xl:h-[274px] rounded-full rotate-126 blur-[120px]", isdark ? "bg-[#5D6EF3] opacity-40" : "bg-[#2A40E7] opacity-40")}/>
      <div className={twMerge("absolute top-[590px] xl:top-[851px] left-[-120px] xl:left-[-260px] w-[150px] h-[131px] xl:w-[300px] xl:h-[262px] rounded-full rotate-126 blur-[100px]",isdark ? "bg-[#FC4FF6] opacity-20" : "bg-[#FF8DFB] opacity-60")}/>
      </section>


      {/* right middle */}
      <section className="relative sm:-translate-y-50 tablet:-translate-y-90 xl:translate-y-0">
      <div className={twMerge("absolute top-[1120px] xl:top-[1012px] right-[-70px] xl:right-[-135px] w-[152px] h-[136px] xl:w-[313px] xl:h-[272px] rounded-full rotate-120 blur-[100px]", isdark ? "bg-[#8593E8] opacity-40" : "bg-[#A1ADF5] opacity-40")}/>
      <div className={twMerge("absolute top-[1220px] xl:top-[1176px] right-[-50px] w-[137px] h-[153px] xl:w-[274px] xl:h-[315px] rounded-full rotate-120 blur-[120px]", isdark ? "bg-[#5D6EF3] opacity-20" : "bg-[#2A40E7] opacity-40")} />
      <div className={twMerge("absolute top-[1300px] xl:top-[1415px] right-[4px] w-[150px] h-[131px] xl:w-[300px] xl:h-[262px] rounded-full rotate-120 blur-[100px]", isdark ? "bg-[#FC4FF6] opacity-20" : "bg-[#FF8DFB] opacity-60")}/>
        </section>

      <div className="">{children}</div>
    </div>
  );
};
